import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ProjectsMenuComponent } from './projects-menu.component'
import { RouterModule } from '@angular/router'
import { DragDropModule } from '@angular/cdk/drag-drop'
import { NgScrollbarModule } from 'ngx-scrollbar'

@NgModule({
  imports: [CommonModule, RouterModule, DragDropModule, NgScrollbarModule],
  declarations: [ProjectsMenuComponent],
  exports: [ProjectsMenuComponent],
  providers: [],
})
export class ProjectsMenuModule {}
